import Call from '../Call';

const BidderPartners = {
    getConfig() {
        return Call(`bidderPartners/config`);
    }
};

export default BidderPartners;


// WEBPACK FOOTER //
// ./src/services/API/components/bidderPartners.js